import React, {FC} from 'react';
import SharedTransactionTable from '../common/SharedTransactionTable';

const RejectedTable: FC = () => {
  return <SharedTransactionTable filterStatus='rejected' />;
};

export default RejectedTable;
